<template>
  <v-app>
    <v-main>
      <Workshop :work-shop-slide.sync="workShopSlide" />
    </v-main>
    <v-card style="padding: 1%;">
      <v-slider
        v-if="!$vuetify.breakpoint.xs"
        v-model="workShopSlide"
        :tick-labels="slideLabels"
        :max="6"
        ticks="always"
        step="1"
        tick-size="5"
        @focus="focused = true"
        @blur="focused = false"
      />
    </v-card>
    <!-- <v-footer style="background-color: #2196F3">
      <v-row align="center" justify="center">
        <v-btn style="margin: 0.5%;" :href="surveyLink" target="_blank"
          >Give Us Feedback</v-btn
        >
      </v-row>
    </v-footer> -->
  </v-app>
</template>

<script>
import "dwnld-attr-polyfill";
import Workshop from "./components/Workshop";

export default {
  name: "App",
  components: {
    Workshop
  },
  data: () => ({
    workShopSlide: 0,
    slideLabels: [
      // "Upcoming Events",
      "Welcome",
      "Engagement",
      "Recommended Alternative",
      "Performance Metrics, Alignment & Stations",
      "Renderings",
      "What's Next",
      "Stay Engaged"
    ],
    focused: false,
    surveyLink:
      "https://campbellton-survey.scoutfeedback.com/MARTA_2040/Campbellton_Corridor_Transit_Project/Campbellton_Corridor_Workshop3/"
  }),
  watch: {
    workShopSlide(val) {
      if (val > 14) {
        this.workShopSlide = 0;
      } else if (val < 0) {
        this.workShopSlide = 6;
      }
    },
    focused(val) {
      if (val) {
        window.removeEventListener("keyup", this.arrowNavigation);
      } else {
        window.addEventListener("keyup", this.arrowNavigation);
      }
    }
  },
  created() {
    window.addEventListener("keyup", this.arrowNavigation);
  },

  mounted() {
    const tickLabels = document.getElementsByClassName("v-slider__tick-label");
    // tickLabels[0].innerHTML = '<span class="tick">Upcoming <br> Events</span>';
    tickLabels[0].innerHTML = '<span class="tick">Welcome</span>';
    tickLabels[1].innerHTML = '<span class="tick">Engagement</span>';
    tickLabels[2].innerHTML =
      '<span class="tick">Recommended <br> Alternative</span>';
    tickLabels[3].innerHTML =
      '<span class="tick">Performance Metrics, <br> Alignment & Stations</span>';
    tickLabels[4].innerHTML = '<span class="tick">Renderings</span>';
    tickLabels[5].innerHTML = "<span class='tick'>What's Next</span>";
    tickLabels[6].innerHTML = '<span class="tick">Stay Engaged</span>';
  },
  methods: {
    moveSlide(number) {
      this.workShopSlide += number;
    },
    arrowNavigation(event) {
      if (event.keyCode === 37) {
        this.moveSlide(-1);
      }
      if (event.keyCode === 39) {
        this.moveSlide(1);
      }
    }
  }
};
</script>

<style>
/* div.v-slider__tick-label {
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  -ms-hyphens: auto !important;
  -moz-hyphens: auto !important;
  -webkit-hyphens: auto !important;
  hyphens: auto !important;
  font-size: small !important;
} */
.v-slider__tick-label {
  font-size: small !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  -ms-hyphens: auto !important;
  -moz-hyphens: auto !important;
  -webkit-hyphens: auto !important;
  hyphens: auto !important;
  text-align: center;
}
.centered {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}
.tick {
  /* background-color: blueviolet; */
  font-size: 1.1em;
  /* text-align: center; */
}
</style>
